<template>    
<div class="card border-0 mt-xl-5">
  <div class="card-body">

    <div class="row">
      <div class="col-12">
        <div  class="row">

          <div class="col-12">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Organization Name<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="Organization Name" v-model="org_name">
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Address Line 1<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="Address Line 1" v-model="org_addr1">
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Address Line 2</label>
              <input type="text" class="form-control" placeholder="Address Line 2" v-model="org_addr2">
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">City<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="City" v-model="org_city">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">State<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <v-select 
                v-model="org_state"
                placeholder="State"
                label="name"
                :options= "stateList"
                :reduce="stateList => stateList.abbreviation"
                class="p-0 bg-white style-chooser">
              </v-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Zip<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="Zip" v-model="org_zip">
            </div>
          </div>
          <div class="col-12 text-right">
            <small><em><i class="fa fa-asterisk text-danger" aria-hidden="true"></i> = Required</span></em></small>
          </div>

          <div class="col-12">
            <button @click="cancelCreate" class="btn btn-danger">Cancel</button>
            <button @click="saveOrg" class="btn btn-success">Save</button>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../../stores/settings-user-main-store.js'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 

      org_name: '',
      org_addr1: '',
      org_addr2: '',
      org_city: '',
      org_state: '',
      org_zip: '',
      stateList: [{ "name": "Alabama", "abbreviation": "AL" },
                  { "name": "Alaska", "abbreviation": "AK" },
                  { "name": "American Samoa", "abbreviation": "AS" },
                  { "name": "Arizona", "abbreviation": "AZ" },
                  { "name": "Arkansas", "abbreviation": "AR" },
                  { "name": "California", "abbreviation": "CA" },
                  { "name": "Colorado", "abbreviation": "CO" },
                  { "name": "Connecticut", "abbreviation": "CT" },
                  { "name": "Delaware", "abbreviation": "DE" },
                  { "name": "District Of Columbia", "abbreviation": "DC" },
                  { "name": "Federated States Of Micronesia", "abbreviation": "FM" },
                  { "name": "Florida", "abbreviation": "FL" },
                  { "name": "Georgia", "abbreviation": "GA" },
                  { "name": "Guam", "abbreviation": "GU" },
                  { "name": "Hawaii", "abbreviation": "HI" },
                  { "name": "Idaho", "abbreviation": "ID" },
                  { "name": "Illinois", "abbreviation": "IL" },
                  { "name": "Indiana", "abbreviation": "IN" },
                  { "name": "Iowa", "abbreviation": "IA" },
                  { "name": "Kansas", "abbreviation": "KS" },
                  { "name": "Kentucky", "abbreviation": "KY" },
                  { "name": "Louisiana", "abbreviation": "LA" },
                  { "name": "Maine", "abbreviation": "ME" },
                  { "name": "Marshall Islands", "abbreviation": "MH" },
                  { "name": "Maryland", "abbreviation": "MD" },
                  { "name": "Massachusetts", "abbreviation": "MA" },
                  { "name": "Michigan", "abbreviation": "MI" },
                  { "name": "Minnesota", "abbreviation": "MN" },
                  { "name": "Mississippi", "abbreviation": "MS" },
                  { "name": "Missouri", "abbreviation": "MO" },
                  { "name": "Montana",  "abbreviation": "MT" },
                  { "name": "Nebraska", "abbreviation": "NE" },
                  { "name": "Nevada", "abbreviation": "NV" },
                  { "name": "New Hampshire", "abbreviation": "NH" },
                  { "name": "New Jersey", "abbreviation": "NJ" },
                  { "name": "New Mexico", "abbreviation": "NM" },
                  { "name": "New York", "abbreviation": "NY" },
                  { "name": "North Carolina", "abbreviation": "NC" },
                  { "name": "North Dakota", "abbreviation": "ND" },
                  { "name": "Northern Mariana Islands", "abbreviation": "MP" },
                  { "name": "Ohio", "abbreviation": "OH" },
                  { "name": "Oklahoma", "abbreviation": "OK" },
                  { "name": "Oregon", "abbreviation": "OR" },
                  { "name": "Palau", "abbreviation": "PW" },
                  { "name": "Pennsylvania", "abbreviation": "PA" }, 
                  { "name": "Puerto Rico", "abbreviation": "PR" }, 
                  { "name": "Rhode Island", "abbreviation": "RI" }, 
                  { "name": "South Carolina", "abbreviation": "SC" }, 
                  { "name": "South Dakota", "abbreviation": "SD" }, 
                  { "name": "Tennessee", "abbreviation": "TN" }, 
                  { "name": "Texas", "abbreviation": "TX" }, 
                  { "name": "Utah", "abbreviation": "UT" }, 
                  { "name": "Vermont", "abbreviation": "VT" }, 
                  { "name": "Virgin Islands", "abbreviation": "VI" }, 
                  { "name": "Virginia", "abbreviation": "VA" }, 
                  { "name": "Washington", "abbreviation": "WA" }, 
                  { "name": "West Virginia", "abbreviation": "WV" }, 
                  { "name": "Wisconsin", "abbreviation": "WI" }, 
                  { "name": "Wyoming", "abbreviation": "WY" }],
    }
  },
  computed: {

  },
  watch: {
  
    
  },
  mounted() {

  },
  methods: {
    

    cancelCreate() {
      var _this = this;
      _this.$emit('onSecondary', [ 'org-create' ])
    },
    saveOrg() {
       var _this = this;
      _this.$toastr.warning('Validating organization information.', 'Please wait!')
      //validate with js
      var valErrors = [];
      //validate org title
      if(_this.org_name == '' || _this.org_name == null || _this.org_name.length < 3) { valErrors.push('A valid organization name of at least three characters is required!') }
      
      //validate addresses
      if(_this.org_addr1 == '' || _this.org_addr1 == null || _this.org_addr1.length < 3) { valErrors.push('An organization requires a valid address.') }
      if(_this.org_city == '' || _this.org_city == null || _this.org_city.length < 3) { valErrors.push('An organization requires a valid city.') }
      if(_this.org_state == '' || _this.org_state == null ) { valErrors.push('An organization requires a valid state.') }
      var zipFormat = /^\d{5}(-\d{4})?$/;  
      if(_this.org_zip == '' || _this.org_zip == null) { valErrors.push('An organization requires an zip code.') }
      if(!_this.org_zip.match(zipFormat)) { valErrors.push("The zip code you entered is invalid. It must be numeric and in the format XXXXX or XXXXX-XXXX") }  


      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.$toastr.remove();


      _this.$toastr.warning('Saving organization information.', 'Please wait!')
      axios.post('/utility/all/org/storeorg', {
        org_name: _this.org_name,
        org_addr1: _this.org_addr1,
        org_addr2: _this.org_addr2,
        org_city: _this.org_city,
        org_state: _this.org_state,
        org_zip: _this.org_zip,
      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', [ 'org-create' ])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    ScalingSquaresSpinner,
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
